import {Injectable} from '@angular/core';
import {ApiRequestService} from './api-request.service';
import {AppConfig} from '../../app-config';
import {Observable, BehaviorSubject, Subject} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {Operator} from '../../pages/user-management/operator/operator.model';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';

export interface UserRequestParam {
    id: number;
    name: string;
    mobile: string;
    email: string;
    statusId: number;
    status: string;
    baseLocation: string;
    createdOn: string;
    password: string;
    username: string;
    role: string[];
    regionIds: any[];
    siteIds: any[];
    loggedInRoleId: any;
    createdBy: number;

}

@Injectable()
export class OperatorService {

    constructor(private apiRequest: ApiRequestService,
                private appConfig: AppConfig, private snackBar: MatSnackBar) {
    }
    // fetch All User
    getAllOperator(pageNumber: any, limit: any): Observable<any> {
        const me = this;
        const userListSubject = new Subject<any>(); // Will use this subject to emit data that we want
        let params: HttpParams = new HttpParams();
        params = params.append('p', pageNumber);
        params = params.append('l', limit);
      /*  params = params.append('s', '0');*/
        me.apiRequest.get(this.appConfig.users_url, params).subscribe(jsonResp => {
            const items = jsonResp.data.map(function (v) {
                return Object.assign({}, v, {
                    id: `${v.id}`,
                    name: `${v.name}`,
                    mobile: `${v.mobile}`,
                    email: `${v.email}`,
                    baseLocation: `${v.baseLocation}`,
                    regionIds: `${v.regionIds}`,
                    siteIds: `${v.siteIds}`,
                    role: `${v.role}`,
                    loggedInRoleId: `${v.loggedInRoleId}`,
                    createdBy: `${v.createdBy}`,
                });
            });

            const userObj = Object.assign({}, jsonResp, {
                data: items
            });
            userListSubject.next(userObj); // incidentList is a Subject and emits an event thats being listened to by the components
        });
        return userListSubject;
    }
    // save user
    save(user: Operator): Observable<any> {
        const me = this;

        const bodyData: UserRequestParam = <UserRequestParam> {
            'email': user.email,
            'mobile': user.mobile,
            'username': user.username,
            'baseLocation': user.baseLocation,
            'name': user.name,
            'password': user.password,
            'createdBy': user.createdBy,
            'regionIds': user.regionIds,
            'siteIds': user.siteIds,
            'role': user.role,
            'loggedInRoleId': user.loggedInRoleId

        };
        console.log('in service: ' + JSON.stringify(bodyData));
        const userDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        me.apiRequest.post(this.appConfig.users_url, bodyData)
            .subscribe(jsonResp => {
                    let userInfoReturn: UserRequestParam;
                    if (jsonResp !== undefined && jsonResp !== null && jsonResp.success === 'true' && jsonResp.data.length !== 0) {
                        const user: Operator = jsonResp.data[0];
                      /*  if (jsonResp.success === 'false') {
                            this.snackBar.open(jsonResp.message, 'Close', {
                                duration: 3000
                            } as MatSnackBarConfig);
                            return;
                        }*/
                        userInfoReturn = <UserRequestParam>{
                            'email': user.email,
                            'mobile': user.mobile,
                            'username': user.username,
                            'baseLocation': user.baseLocation,
                            'name': user.name,
                            'password': user.password,
                            'createdBy': user.createdBy,
                            'regionIds': user.regionIds,
                            'siteIds': user.siteIds,
                            'role': user.role,
                            'loggedInRoleId': user.loggedInRoleId
                        };

                    } else {
                      //  console.log('added:----:' + jsonResp.message);
                        this.snackBar.open(jsonResp.message, 'Close', {
                            duration: 3000
                        } as MatSnackBarConfig);
                    }
                    userDataSubject.next(userInfoReturn);
                },
                err => {
                    console.log('added err:----:' + err);
                });

        return userDataSubject;
    }
    // update user
    update(user: Operator, id: number): Observable<any> {
        const me = this;

        const bodyData = {
            'id': user.id,
            'email': user.email,
            'username': user.username,
            'mobile': user.mobile,
            'baseLocation': user.baseLocation,
            'name': user.name,
            'password': user.password,
            'createdBy': user.createdBy,
            'regionIds': user.regionIds,
            'siteIds': user.siteIds,
            'role': user.role,
            'loggedInRoleId': user.loggedInRoleId,

        };
console.log(JSON.stringify(bodyData));
console.log("lo" + user.role);
        const userDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        me.apiRequest.put(this.appConfig.users_url + '/' + id, bodyData)
            .subscribe(jsonResp => {
                    let userInfoReturn: UserRequestParam;
                    if (jsonResp !== undefined && jsonResp !== null && jsonResp.success === 'true' && jsonResp.data.length !== 0) {
                        const user: Operator = jsonResp.data[0];
                        userInfoReturn =  <UserRequestParam> {
                            'id': user.id,
                            'email': user.email,
                            'username': user.username,
                            'mobile': user.mobile,
                            'baseLocation': user.baseLocation,
                            'name': user.name,
                            'password': user.password,
                            'createdBy': user.createdBy,
                            'regionIds': user.regionIds,
                            'siteIds': user.siteIds,
                            'role': user.role,
                            'loggedInRoleId': user.loggedInRoleId
                        };

                    } else {
                        console.log('updated :----:' + jsonResp.message);
                    }
                    userDataSubject.next(userInfoReturn);
                },
                err => {
                    console.log('update  err:----:' + err);
                });

        return userDataSubject;
    }

    deleteOperator(id: number): Observable<any> {
        const me = this;
        return me.apiRequest.delete(this.appConfig.users_url + '/' + id);
    }

}
